module.exports = __webpack_public_path__ + "img/allgemeine-struktur.02f0781e.png";